import events from 'events';
import $ from '@ali/tarzan-zepto';
import smiley from '@ali/tarzan-smiley';
import IScroll from 'iscroll/build/iscroll-probe.js';
import APPConfig from './config';
import util from '../../lib/util';
import smileyTemplate from './tpl.html';

import './style.scss';

const w = $('.m-alicare').width();
const TAP = util.isPC() ? 'click' : 'tap';

const LOG_C = 'smiley';

export default class Smiley extends events {

  constructor(config) {
    super();
    this.__show = false;
    this.$container = null;
    this.config = config;
    this.width = config.size.width;
    this.log = config.log;
    this.scrollerList = [];
    this.smileyList = [{
      type: 'default',
      icon: 'https://gw.alicdn.com/tps/TB1sHe9PpXXXXXfXVXXXXXXXXXX-36-36.png',
      data: APPConfig.WWSmiley,
    }];
  }

  addCustomSmiley(list) {
    list.forEach((t) => {
      t.data = smiley[t.name];
      this.smileyList.push(t);
    });
  }

  render() {
    // const smileyList = [{
    //   type: 'default',
    //   icon: 'https://gw.alicdn.com/tps/TB1sHe9PpXXXXXfXVXXXXXXXXXX-36-36.png',
    //   data: APPConfig.WWSmiley,
    // }, {
    //   type: 'xm',
    //   icon: 'https://gw.alicdn.com/tps/TB1N2jXPpXXXXbmXFXXXXXXXXXX-37-41.png',
    //   data: smiley.XIAO_MI,
    // }];
    // console.log(this.smileyList);
    const $node = $(smileyTemplate.render({
      data: this.smileyList,
    }));

    $node.find('.J_Wrapper').width(this.width);
    const $items = $node.find('.J_SmileyItem');
    $items.each((idx, item) => {
      $(item).width(this.width);
    });
    $node.find('.mod-smiley-item').each((index, t) => {
      const $scroller = $(t).find('.J_Scroller');
      const $indicator = $(t).find('.indicator');
      const len = $(t).find('.J_SmileyItem').length;
      $scroller.width(len * this.width);
      // 小圆点的宽度设置，记住公式
      $indicator.width((len * 6) + ((len - 1) * 3));
    });

    $(this.config.container).append($node);

    this.$container = $node;
  }

  slider() {
    const $wrapperList = this.$container.find('.mod-smiley-item');
    $wrapperList.each((index, t) => {
      const $t = $(t);
      const scroller = new IScroll($t.find('.J_Wrapper')[0], {
        scrollX: true,
        scrollY: false,
        momentum: false,
        snap: true,
        snapSpeed: this.width,
        disablePointer: true,
        disableTouch: false,
        disableMouse: false,
        indicators: {
          el: $t.find('.indicator')[0],
          resize: false,
        },
      });
      scroller.refresh();
      this.scrollerList.push(scroller);
    });
  }

  bindEvt() {
    let $previewDom = null;
    this.$container.delegate('li', TAP, (ev) => {
      const index = $(ev.currentTarget).attr('data-id');
      const type = $(ev.currentTarget).attr('type');
      this.emit('message', {
        text: index,
        type,
      });
      this.log.send({
        c: LOG_C,
        d: 'send',
      });
    });

    // 长按出现表情预览
    this.$container.delegate('li', 'longTap', (ev) => {
      const $tar = $(ev.currentTarget);
      // 当前在第几个iscroll
      const index = this.$container.find('.mod-smiley-item').index($tar.parents('.mod-smiley-item'));
      if ($tar.attr('type') === 'liveImage') {
        let gif = $tar.attr('data-gif');
        $tar.addClass('active');
        gif = gif.replace('.gif', '@2x.gif');
        gif = gif.replace('.png', '@2x.png');
        $previewDom = $(`<div class="liveImagePreview"><img src="${gif}" alt="" /></div>`);

        let left = $tar[0].offsetLeft + this.scrollerList[index].x;
        // 不超越屏幕
        if (left < 5) {
          left = 5;
        }
        if (left > w - 105) {
          left = w - 105;
        }
        $previewDom.css({
          left,
          bottom: (140 - $tar[0].offsetTop) + 70,
        });
        $('body').append($previewDom);
        this.log.send({
          c: LOG_C,
          d: 'preview',
        });
      }
    });

    // 松开删除预览
    this.$container.delegate('li', 'touchend', (ev) => {
      const $tar = $(ev.currentTarget);
      if ($previewDom)$previewDom.remove();
      $tar.removeClass('active');
    });

    // 切换tab
    this.$container.delegate('.J_Tab', TAP, (ev) => {
      const $tab = $(ev.currentTarget);
      const index = this.$container.find('.J_Tab').index($tab);
      $tab.siblings().removeClass('selected');
      $tab.addClass('selected');
      this.$container.find('.mod-smiley-item').hide();
      this.$container.find('.mod-smiley-item').eq(index).show();

      this.scrollerList[index].refresh();
      this.log.send({
        c: LOG_C,
        d: 'tab',
        ext: {
          position: index,
        },
      });
    });
  }

  show() {
    if (!this.__show) {
      this.render();
      this.slider();
      this.bindEvt();
      this.__show = true;
    }
    this.$container.show();
    this.emit('show');
    this.scrollerList.forEach((t) => {
      t.refresh();
    });
  }

  refresh() {
    this.scrollerList.forEach((t) => {
      t.refresh();
    });
  }


  hide() {
    if (this.$container) {
      this.$container.hide();
      this.emit('hide');
    }
  }

}




// WEBPACK FOOTER //
// ./src/component/smiley/index.js